import img1 from "./images/illustration/team-member-6.jpg";
import img2 from "./images/illustration/team-member-2.jpg";

const Crossfit = () => {
  return (
    <>
      <section className=" container-fluid" id="demo">
        <section className="container">
          <section className="row px-5 mt-5">
            <div col-12>
              <h2 className="heading fw-bold mb-4">
                TESTIMONIALS FROM CLIENTS
              </h2>
            </div>
            <p>
              Convallis ullamcorper velit, varius maecenas viverra purus nunc.
              In suscipit aliquet sociis nibh quis.<br></br> Neque pellentesque
              habitant aliquet venenatis at est.
            </p>

            <div className="col-12 col-md-6 mt-5 px-5">
              <h3>
                "TINCIDUNT CONGUE TURPIS NISL,VEL ALIQUET SAGITTIS,PURUS,
                <br />
                CONSEQUAT.LEO VEL AENEAN LECTUS."
              </h3>
              <img
                src={img1}
                alt="iamge not found"
                className="img-fluid w-75"
              />
            </div>
            <div className="col-12 col-md-6 mt-5 px-5">
              <h3>
                "NULLA MOLESTIE ALIQUAM DICTUM SUSPENDISSE
                <br /> VULPUTATE DIS FACILISI.NIBH VITAE TORTOR,NON DOLOR"
              </h3>
              <img src={img2} alt="imge not found" className="img-fluid w-75" />
            </div>
          </section>
        </section>
      </section>
    </>
  );
};

export default Crossfit;
